module.exports = __webpack_public_path__ + "static/img/2.ecf986b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/index/vip-banner/2.jpg
// module id = pmZC
// module chunks = 0